<template>
  <div>
    <div class="brand-logo">
      <BrandLogo
        name="Independent Music Label"
        :logo="require('../../../assets/brands_logo_3_big.png')"
        desc="Beijing WantU Music Culture Communication Co., Ltd."
      ></BrandLogo>
    </div>
    <BrandIntro class="brand-intro" :lineArray="array"></BrandIntro>
    <div class="products">
      <div class="products__block">
        <div class="products__block__title">Performance</div>
        <img
          class="products__block__img"
          src="../../../assets/brands_image_5.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
import BrandLogo from "./BrandLogo";
import BrandIntro from "./BrandIntro"
export default {
  data() {
    return {
      array: [
          "Top domestic music brands – produce and present small to medium-sized music live concerts",
          "Professional entertainment managers, production teams,Asia-based sponsors/organizers, publicity manager",
          "The agency sponsors around 13 groups in total",
          "The only agency to claim a library of 500 songs",
          "Features 200+ solo artists and groups, with up to 2000 live performances",
          `Recognized as “The Highest-Returning Music Company"`  
      ]
    };
  },
  components: {
    BrandLogo,
    BrandIntro
  }
};
</script>
<style lang="scss" scoped>
.brand-logo {
  padding: 64px 0 54px 0;
  text-align: center;
}
.brand-intro{
  width: 1200px;
  margin: 0 auto;
}
.products {
  padding-bottom: 60px;
  background-color: #1f1f1f;
  overflow: hidden;
  &__block {
    &__title {
      color: #ec6900;
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      font-size: 26px;
      margin-top: 58px;
    }
    &__img {
      display: block;
      margin: 31px auto 0 auto;
    }
  }
}
</style>